import React, { useState, useEffect } from "react";
import {
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonIcon,
  IonPage,
  IonRow,
} from "@ionic/react";
import { NurseManagementService } from "./NurseManagementService";
import { utilService } from "../../services";
import SelectNurse from "./components/SelectNurse/SelectNurse";
import SelectPhone from "./components/SelectPhone/SelectPhone";
import SelectBed from "./components/SelectBed/SelectBed";
import {
  FormattedGetSitesData,
  FormattedUnitsData,
} from "./NurseMgmtDataModels";
import "./NurseManagement.scss";
import useNurseManagementDataUpdate from "./components/NurseManagementDataUpdate/NurseManagementDataUpdate";
import { ApiResponse } from "../../models";
import { useToast } from "@agney/ir-toast";
import SearchableDropdown from "../../components/Shared/SearchableDropdown/SearchableDropdown";
import SelectSite from "./components/SelectSiteModal/SelectSiteModal";
import { chevronDownOutline } from "ionicons/icons";
import { useTranslation } from "react-i18next";

export const NurseContext = React.createContext({
  selectedUnit: "",
  selectedNurseGuid: "",
  selectedNurseId: "",
});


const NurseManagement: React.FunctionComponent = () => {
  const Toast = useToast();
  const { t } = useTranslation("nursemanagement");  

  const [sitesList, setSitesList]: [[], Function] = useState([]);
  const [showSiteModal, setShowSiteModal]: any = useState(false);

  const [selectedSites, setSelectedSite]: [number[], Function] = useState([]);
  const [selectedSiteNames, setSelectedSiteNames]: [number[], Function] =
    useState([]);
  const [unitsList, setUnitsList]: [[], Function] = useState([]);
  const [unitsFormattedList, setUnitsFormattedList]: [[], Function] = useState(
    []
  );
  const [selectedUnit, setSelectedUnit]: [string, Function] = useState("");
  const [resetData, setResetData]: [boolean, Function] = useState(true);
  const [selectedNurseGuid, setSelectedNurseGuid]: [string, Function] =
    useState("");
  const [selectedNurseId, setSelectedNurseId]: [string, Function] =
    useState("");
  const [reloadData, setReloadData]: [boolean, Function] = useState(true);
  const [activeTabInMobile, setActiveTabInMobile]: [number, Function] =
    useState(1);
  const [currentScreenSize, setCurrentScreenSize]: [string, Function] =
    useState("large");

  const { nurseMgmtUpdateData, setNurseUpdateData, resetUpdateData } =
    useNurseManagementDataUpdate();

  useEffect(() => {
    setScreenWidth();
    getSites();
  }, []);

  useEffect(() => {
    setUnitsFormattedList([]);
    setSelectedUnit("");
    setResetData(true);
    setSelectedNurseGuid("");
    selectedSites.length && getUnits();
  }, [selectedSites]);

  const setScreenWidth = () => {
    const currentScreenSize = utilService.getScreenSize();
    setCurrentScreenSize(currentScreenSize);
    if (currentScreenSize === "small") {
      setActiveTabInMobile(1);
    }
  };

  const getSites = async () => {
    const sitesData: FormattedGetSitesData =
      await NurseManagementService.getSites({
        reg_code: utilService.getNetwork(),
        guid: utilService.getLoggedUserGuid(),
      });
    if (sitesData.isSuccess) {
      setSitesList(sitesData.responseData);
    }
  };

  const getUnits = async () => {
    const unitsData: FormattedUnitsData = await NurseManagementService.getUnits(
      {
        siteId: `[${selectedSites.toString()}]`,
        reg_code: utilService.getNetwork(),
      }
    );
    if (unitsData.response.isSuccess) {
      setUnitsList(unitsData.response.result);
      setUnitsFormattedList(unitsData.formattedUnitData);
    }
  };

  const handleUnitSelection = (selectedValue: any) => {
    setResetData(false);
    setSelectedUnit(selectedValue);
    setSelectedNurseGuid("");
    setSelectedNurseId("");
    resetUpdateData();
  };

  const setUpdateData = (
    unitId: string,
    nurseId: string,
    phoneObj: { number: string; id: number },
    bedObj: { id: number; action: string },
    nurseGuid: string,
    source: string
  ) => {
    setNurseUpdateData(unitId, nurseId, phoneObj, bedObj, nurseGuid, source);
  };

  const updateNurse = async () => {
    nurseMgmtUpdateData.forEach((updateObj) => {
      if (updateObj.phoneNumber === "") delete updateObj.phoneNumber;
    });
    const updateResponse: ApiResponse =
      await NurseManagementService.updateNurseData({
        data: nurseMgmtUpdateData,
        reg_code: utilService.getNetwork(),
      });
    if (updateResponse.isSuccess) {
      Toast.success(t("dataUpdatedSuccessfully"));
      setReloadData(false);
      setReloadData(true);
    } else {
      Toast.error(updateResponse.message);
    }
  };

  const onSitesModalClose = (sites: []) => {
    const siteIds: any = [];
    const siteNames: any = [];
    sites.forEach((selectedItem: any) => {
      siteIds.push(selectedItem.dataId);
      siteNames.push(selectedItem.dataName);
    });
    setSelectedSite(siteIds);
    setSelectedSiteNames(
      sitesList.length === sites.length
        ? t("all")
        : sites.length === 0
        ? t("selectSite")
        : siteNames.toString()
    );
  };

  const isUpdateBtnDisabled = () => {
    if (nurseMgmtUpdateData?.length > 0) {
      return !nurseMgmtUpdateData?.find(
        (nurse) =>
          nurse?.nurseId === selectedNurseId 
        // &&
          // (nurse?.bedList.length > 0 || nurse?.phoneNumber)
      );
    } else {
      return true;
    }
  };

  return (
    <IonPage>
      <IonContent>
        <div className="nurse-mgmt-page-container">
          <IonGrid className="nurse-mgmt-grid">
            <IonRow>
              <IonCol size-md="3" size-lg="3" size="12">
                <label className="label">
                  <span className="mandatory-sign">*</span>{t("selectSite")}
                </label>
                <div>
                  <div
                    className="site-dropdown-wrapper"
                    onClick={() => setShowSiteModal(true)}
                  >
                    {/* {JSON.stringify(selectedSiteNames)} */}
                   {selectedSiteNames.length === 0
  ? t("selectSite")
  : selectedSiteNames}
                  </div>
                  <IonIcon
                    icon={chevronDownOutline}
                    className="select-arrow-down"
                  ></IonIcon>
                  <SelectSite
                    showModal={showSiteModal}
                    onOk={(selectedSites: any) => {
                      onSitesModalClose(selectedSites);
                      setShowSiteModal(false);
                    }}
                    listData={sitesList}
                    onCancel={() => {
                      setShowSiteModal(false);
                    }}
                  />
                </div>
              </IonCol>
              <IonCol size-md="3" size-lg="3" size="12">
                <label className="label">
                  <span className="mandatory-sign">*</span>{t("selectUnit")}
                </label>
                <div className="site-drpdwn-container">
                  <SearchableDropdown
                    options={unitsFormattedList}
                    value={selectedUnit}
                   placeholder={t("selectUnit")}
                    onChange={handleUnitSelection}
                  ></SearchableDropdown>
                </div>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="12">
                <div className="card-parent-container">
                  <NurseContext.Provider
                    value={{
                      selectedUnit: selectedUnit,
                      selectedNurseGuid: selectedNurseGuid,
                      selectedNurseId: selectedNurseId,
                    }}
                  >
                    <IonRow>
                      <IonCol
                        size-sm="12"
                        size-md="12"
                        size-lg="4"
                        className={`update-data-section ${
                          currentScreenSize === "large" ||
                          activeTabInMobile === 1
                            ? "d-block"
                            : "d-none"
                        }`}
                      >
                        {reloadData && (
                          <SelectNurse
                            unitsList={unitsList}
                            resetData={resetData}
                            setSelectedNurseGuid={setSelectedNurseGuid}
                            setSelectedNurseId={setSelectedNurseId}
                            setActiveTabInMobile={setActiveTabInMobile}
                          />
                        )}
                      </IonCol>
                      <IonCol
                        size-sm="12"
                        size-md="12"
                        size-lg="4"
                        className={`update-data-section ${
                          currentScreenSize === "large" ||
                          activeTabInMobile === 2
                            ? "d-block"
                            : "d-none"
                        }`}
                      >
                        {reloadData && (
                          <SelectPhone
                            resetData={resetData}
                            setUpdateData={setUpdateData}
                            setActiveTabInMobile={setActiveTabInMobile}
                          />
                        )}
                      </IonCol>
                      <IonCol
                        size-sm="12"
                        size-md="12"
                        size-lg="4"
                        className={`update-data-section ${
                          currentScreenSize === "large" ||
                          activeTabInMobile === 3
                            ? "d-block"
                            : "d-none"
                        }`}
                      >
                        {reloadData && (
                          <SelectBed
                            resetData={resetData}
                            setUpdateData={setUpdateData}
                            setActiveTabInMobile={setActiveTabInMobile}
                          />
                        )}
                      </IonCol>
                    </IonRow>
                  </NurseContext.Provider>
                  <IonRow>
                    <IonCol size="12">
                      <div className="d-flex justify-content-end update-btn-container">
                        <IonButton
                          className="button primary-btn btn-curved"
                          disabled={isUpdateBtnDisabled()}
                          onClick={() => updateNurse()}
                        >
                            {t("update")}
                        </IonButton>
                      </div>
                    </IonCol>
                  </IonRow>
                </div>
              </IonCol>
            </IonRow>
          </IonGrid>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default NurseManagement;
